export const token = localStorage.getItem("access_token"); // Get token from localStorage
export const devUrl = "https://backend.fastest.academy/api/secured_media_access" // dev url

// hgchgdgkh

